// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__2AZYJ","cross":"classes_cross__S6Psj","right-arrow":"classes_right-arrow__paLFu","left-up-arrow":"classes_left-up-arrow__1IYtA"};